import React from 'react';
import styles from '@cp/pages/AmeyoUtility/components/UploadNumbers/index.module.scss';
import { CheckIcon, CloseIcon } from '@icons';
import Button from '@primitives/Button';
import cx from 'classnames';
import CircularLoader from '@navi/web-ui/lib/icons/CircularLoaderIcon';

type UploadSuccessComponent = {
  name: string;
  onCancel: () => void;
  containerClassName?: string;
  isInProgress?: boolean;
  showCancelIcon?: boolean;
};

function UploadSuccessComponent({
  name,
  onCancel,
  containerClassName,
  isInProgress,
  showCancelIcon = true
}: UploadSuccessComponent) {
  return (
    <div
      className={cx(
        'flex items-center justify-between text-gray-600 p-1.5 mt-3.5 rounded-lg border border-solid border-green-500 bg-[var(--upload-component-border)] h-[40px] ml-3 gap-2',
        { '!bg-[--blue-background-primary]': isInProgress, '!border-[--blue-base]': isInProgress },
        containerClassName
      )}
    >
      <div className="flex gap-2">
        <div>
          {isInProgress ? (
            <CircularLoader
              width={20}
              height={20}
              color="var(--blue-base)"
              fill={'var(--blue-base)'}
            />
          ) : (
            <CheckIcon width={20} height={20} color="var(--green-base)" fill="var(--green-base)" />
          )}
        </div>
        <div className="max-w-[240px] text-ellipsis  overflow-hidden whitespace-nowrap">{name}</div>
      </div>
      {showCancelIcon ? (
        <Button variant="text" onClick={onCancel}>
          <CloseIcon />
        </Button>
      ) : null}
    </div>
  );
}

export default UploadSuccessComponent;
